import { galateaSchema } from '@inkitt/titan/schemas/galatea';
import { createSelectSchema } from 'drizzle-zod';
import { z } from 'zod';
import { c } from '../../contract';

// `firebase_id` (the Firebase auth uid) is omitted from the public v1 contract: it is an
// auth identifier that must not be exposed on the unauthenticated comments endpoint, and it is
// redundant (we use `user_id`). `user_id` is kept — it's still used for reply push-notifications.
// `sentiment_score` is an internal ranking signal and is not part of the public response.
export const usersStoriesComments = createSelectSchema(galateaSchema.userStoriesComments).omit({
  firebase_id: true,
  sentiment_score: true,
});

export const userStoriesCommentsRouter = c.router(
  {
    getComments: {
      summary: 'Get comment for story episode',
      method: 'GET',
      path: '',
      query: z.object({
        story: z.string(),
        episode: z.number(),
        page: z.number().optional(),
        per_page: z.number().optional(),
      }),
      responses: {
        200: z.array(usersStoriesComments).or(
          z.object({
            comments: z.array(usersStoriesComments),
          }),
        ),
      },
    },
    postComment: {
      summary: 'Create comment for story episode',
      method: 'POST',
      path: '',
      body: z.object({
        story: z.string(),
        body: z.string(),
        episode: z.number(),
        username: z.string(),
        user_id: z.string(),
        body_length: z.number().optional(),
        ts: z.number(),
        path: z.string(),
      }),
      responses: {
        201: z.object({
          status: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/comments',
  },
);
